import './fragments.less'

import Parallax from 'parallax-js'
import React, {useEffect, useRef} from 'react'

export const Fragments: React.FC<{
	theme: string
}> = ({theme}) => {
	const dom = useRef(null)

	useEffect(() => {
		const parallax = new Parallax(dom.current)

		return () => {
			parallax.destroy()
		}
	})

	return (
		<div ref={dom} className={`fragments theme-${theme}`}>
			<FragmentsItem
				depth={0.6}
				points="14.8,68.2 45.8,54.5 24.8,105.5 0,108.7"
			/>
			<FragmentsItem
				depth={0.4}
				points="66.3,39.5 123,85.4 178.7,44.9 139.8,7.9"
			/>
			<FragmentsItem
				depth={0.5}
				points="38.3,123.8 72.2,99.5 95.5,163.3 23,190"
			/>
			<FragmentsItem
				depth={0.2}
				points="141.7,160 162.7,111.8 197.7,139.5 180.7,202.2"
			/>
			<FragmentsItem
				depth={0.3}
				points="223.2,99.2 224.8,105.5 246.5,126 245.3,111.2"
			/>
			<FragmentsItem depth={0.7} points="249.3,35.2 250.2,48.2 278.5,74.5" />
			<FragmentsItem depth={0.6} points="279.2,0 301.8,62.7 315.8,32" />
			<FragmentsItem
				depth={0.8}
				points="260.7,150.7 260.5,165.7 306.5,147.3 303.8,138.8"
			/>
		</div>
	)
}

export const FragmentsItem: React.FC<{
	depth: number
	points: string
}> = ({depth, points}) => {
	return (
		<div className="fragments-layer">
			<svg
				className="fragments-layer-fragment"
				version="1.1"
				width="315.8px"
				height="202.2px"
				viewBox="0 0 315.8 202.2"
				preserveAspectRatio="xMidYMid slice"
				{...{space: 'preserve'}}
			>
				<polygon className="fragments-layer-fragment-polygon" points={points} />
			</svg>
		</div>
	)
}
